let PlayersSympathy = {
    SYMPATHY_SET_PLAYERS: 'SYMPATHY_SET_PLAYERS',
};

export default PlayersSympathy;
